import { OcelotConfig } from '@/types/ocelotConfig';

const BaseConfig: OcelotConfig = {
  search: {
    header: {
      invalid: 'Ogiltig sökning. Prova igen.',
      success: 'Sökresultat för [term]',
      noHits: 'Inga träffar för [term]',
      count: '[count] Resultat',
      error: 'Ojdå! Ett fel uppstod. Prova igen.',
    },
    noTitleText: 'Ingen titel',
    googleCustomSearch: {
      apiKey: 'AIzaSyDzPGtrEiLnkUhfqxc-4zK0xNwMHvvZVSk',
      id: '',
    },
    placeholderImage: '',
  },
  analytics: {
    brandName: '',
    google: {
      gtm: 'GTM-NNQ7462Q',
      dimensions: {
        page_id: '',
        mobile_website: '',
        categories: '',
      },
      viewId: 0,
      hostname: '',
    },
    parsely: {
      siteId: '',
    },
    avo: {
      apiKey: '',
    },
    funnelRelay: {
      customerId: '',
      scriptSource: '',
    },
    tags: [],
    jwplayer: true,
  },
  features: {
    affiliateGallery: {
      enabled: true,
      apiBaseUrl: 'https://se-affiliate-gallery.aws.aller.com',
      apiEndpoint: '/api/v2/sites/[site]/populated/',
      excludedAccessLevels: ['purchase'],
    },
    nextVideoRecommendation: {
      enabled: true,
    },
    payments: {
      v1: { purchaseTag: undefined },
      v2: {
        defaultPlan: '',
        checkoutConfiguration: 'se-plus-default-checkout',
        bffOAuth: {
          scope: '',
          audience: '',
        },
      },
    },
    recommendedArticles: {
      enabled: true,
      excludedAccessLevels: ['purchase'],
    },
    login: {
      v1: {
        enabled: false,
        brandName: '',
        isUserMigrationEnabled: false,
      },
      v2: { enabled: false },
    },
    infinityScrollArticle: {
      enabled: false,
      excludedAccessLevels: ['purchase'],
    },
    infinityScrollFront: {
      enabled: true,
      title: 'Mest läst',
      mode: 'front',
      excludedAccessLevels: ['purchase'],
      explicitRoute: [],
    },
    keesingGames: {
      enabled: false,
      customerId: '',
      scriptPath: '',
      stylesPath: '',
      frontPagePathname: '',
      games: [
        { slug: 'bildkryss', gameType: 'arrowword_plus', puzzleId: 'arrowword_plus_today', requiresLogin: true },
        {
          slug: 'minibildkryss',
          gameType: 'arrowword_plus_mini',
          puzzleId: 'arrowword_plus_mini_today',
          requiresLogin: true,
        },
        { slug: 'sudoku', gameType: 'sudoku', puzzleId: 'sudoku_today', requiresLogin: true },
        { slug: 'tectonic', gameType: 'tectonic', puzzleId: 'tectonic_today', requiresLogin: true },
        { slug: 'ordroj', gameType: 'wordguess', puzzleId: 'wordguess_today', requiresLogin: false },
        { slug: 'sokord', gameType: 'wordsearch', puzzleId: 'wordsearch_today', requiresLogin: false },
        { slug: 'brobyggare', gameType: 'hashi', puzzleId: 'hashi_today', requiresLogin: true },
        { slug: 'jewel-academy', gameType: 'CG_JewelAcademy', puzzleId: 'CG_JewelAcademy', requiresLogin: false },
        { slug: 'daily-mahjong', gameType: 'cg_dailymahjong', puzzleId: 'CG_DailyMahjong', requiresLogin: false },
        { slug: 'bubble-academy', gameType: 'CG_BubbleAcademy', puzzleId: 'CG_BubbleAcademy', requiresLogin: false },
        { slug: 'kategoriskt', gameType: 'wordgroups', puzzleId: 'wordgroups_today', requiresLogin: false },
        { slug: 'woodblocks', gameType: 'CG_WoodBlocks', puzzleId: 'CG_WoodBlocks', requiresLogin: false },
        { slug: 'sambandet', gameType: 'arrowword_plus', puzzleId: 'arrowword_plus_today', requiresLogin: false },
      ],
    },
    liveBlog: {
      enabled: false,
      tenant: '',
      channelId: '',
      headline: '',
      description: '',
      seoTitle: '',
      seoDescription: '',
      post: {
        titleSuffix: '',
      },
    },
    article: {
      showNewsDisclaimer: false,
      saveArticle: {
        enabled: false,
        excludedAccessLevels: [],
      },
    },
    highlightedArticles: {
      inject: true,
      exclude: {
        urls: [],
        labradorPageTypes: [],
        labradorMetaPageTypes: [],
        accessLevels: ['purchase'],
        categories: [],
      },
      position: {
        article: 'auto',
        front: 'auto',
      },
    },
    trendingMenu: {
      inject: true,
      exclude: {
        urls: [],
        labradorPageTypes: [],
        labradorMetaPageTypes: [],
        accessLevels: ['purchase'],
        categories: [],
      },
      position: {
        article: 'auto',
        front: 'auto',
      },
      label: 'Populärt: ',
      tagPrefixes: [],
    },
    direktBanner: {
      inject: false,
      exclude: {
        urls: [],
        labradorPageTypes: [],
        labradorMetaPageTypes: [],
        accessLevels: ['purchase'],
        categories: ['creative studio'],
      },
      position: {
        article: 'auto',
        front: 'auto',
      },
    },
    banner: {
      inject: false,
      exclude: {
        urls: [],
        labradorPageTypes: [],
        labradorMetaPageTypes: [],
        accessLevels: ['purchase'],
        categories: [],
      },
      position: {
        article: 'auto',
        front: 'auto',
      },
    },
    videoReels: {
      inject: false,
      scriptSrc: '',
      playlistId: '',
      exclude: {
        urls: [],
        labradorPageTypes: [],
        labradorMetaPageTypes: [],
        accessLevels: [],
        categories: [],
      },
      position: {
        article: 'auto',
        front: 'auto',
      },
    },
    newsletterSignup: {
      enabled: true,
      availableNewsletters: {},
    },
  },
  pages: {
    author: {
      enabled: true,
      headline: 'Våra skribenter',
      description: '',
      requestArticles: {
        extraQuery: '',
      },
    },
    instagram: {
      enabled: true,
    },
    video: {
      enabled: true,
    },
    '21-dagar': {
      enabled: false,
    },
    confirmation: {
      enabled: false,
    },
    direkt: {
      enabled: false,
    },
    rssPlus: {
      enabled: false,
    },
    reels: {
      enabled: true,
    },
  },
  seo: {
    schemaMarkup: {
      name: '',
      foundingDate: '',
      alternateName: [],
      sameAs: [],
      webPages: [],
      publishingPrinciples: '',
      verificationFactCheckingPolicy: '',
      correctionsPolicy: '',
      unnamedSourcesPolicy: '',
      missionCoveragePrioritesPolicy: '',
    },
    etikett: {
      minimumArticles: 5,
    },
  },
  contentBox: {
    articleTeaser: {
      fieldSettings: {
        title: {
          textSize: {
            allowCmsOverride: true,
            default: {
              desktop: 40,
              mobile: 30,
            },
            fieldFunction: 'textSize',
          },
        },
        subtitle: {
          textSize: {
            allowCmsOverride: true,
            default: {
              desktop: 20,
              mobile: 20,
            },
            fieldFunction: 'textSize',
          },
        },
      },
    },
    textTitle: {
      fieldSettings: {
        title: {
          textAlign: {
            allowCmsOverride: true,
            default: {
              desktop: 'left',
              mobile: 'left',
            },
          },
          textBackgroundColor: {
            allowCmsOverride: true,
            default: {
              desktop: '',
              mobile: '',
            },
          },
          textColor: {
            allowCmsOverride: true,
            default: {
              desktop: '',
              mobile: '',
            },
          },
          italic: {
            allowCmsOverride: true,
            default: {
              desktop: '',
              mobile: '',
            },
          },
        },
      },
    },
    textSubtitle: {
      fieldSettings: {
        subtitle: {
          textAlign: {
            allowCmsOverride: true,
            default: {
              desktop: 'left',
              mobile: 'left',
            },
          },
          textBackgroundColor: {
            allowCmsOverride: true,
            default: {
              desktop: '',
              mobile: '',
            },
          },
          textColor: {
            allowCmsOverride: true,
            default: {
              desktop: '',
              mobile: '',
            },
          },
          italic: {
            allowCmsOverride: true,
            default: {
              desktop: '',
              mobile: '',
            },
          },
        },
      },
    },
    jwVideo: {
      fieldSettings: {
        title: {
          textSize: {
            allowCmsOverride: true,
            default: {
              desktop: 40,
              mobile: 30,
            },
            fieldFunction: 'textSize',
          },
        },
      },
    },
    markup: {
      fieldSettings: {
        markup: {
          dataValue: true,
        },
      },
    },
  },
  mobileApp: {
    enabled: false,
    meta: {
      'al:android:url': '',
      'al:android:app_name': '',
      'al:android:package': '',
      'al:ios:url': '',
      'al:ios:app_store_id': '',
      'al:ios:app_name': '',
      'al:web:should_fallback': '',
    },
  },
  ads: {
    video: {
      autoPlay: '',
      clickToPlay: '',
      videoPage: '',
    },
    exceptionPaths: {},
    preload: {
      enabled: true,
    },
  },
  cmp: {
    didomi_api_key: 'c1eb5055-7d6a-46f3-a77e-c352eabafd5d',
    didomi_notice_id: '8YBa26NY',
    preload: {
      enabled: true,
    },
  },
  labrador: {
    helperService: 'https://se-labrador-helper-services.labrador.allermedia.io',
  },
  common: {
    redirects: [],
    format: {
      date: 'D MMMM YYYY',
      time: 'HH:mm',
      dateTime: 'D MMMM YYYY HH:mm',
    },
  },
};

export default BaseConfig;
